import React from 'react';
import { Box, Button, Checkbox, Divider, FormControl, FormControlLabel, Link, Paper, SvgIcon, Typography } from '../../../elements';
import { Container, Title } from './Step.style';
import { t } from '../../../../../js/common/translations';
import ReCAPTCHA from 'react-google-recaptcha';

const StepThree = ({
  handleSetStep,
  handleSubmit,
  loading,
  visitForm,
  propertyAddress,
  locale,
  siteKey,
  recaptchaRef,
  getErrorMessage,
  memberSignedIn,
  handleCheckbox,
  checkboxValue
}) => {
  const date = new Date(visitForm.date);
  const optionsDate = {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  };

  return (
    <Container>
      <Paper sx={{ padding: '24px', maxWidth: { xs: '100%', md: '575px' } }}>
        <Box>
          <Title sx={{ mb: '2rem' }}>{t('visit_form.step_three.title')}</Title>
          <Box display='flex'>
            <SvgIcon name="calendar" sx={{ m: '1rem', mr: '1.5rem' }} size="25" />
            <Box display="flex" sx={{ flexDirection: 'column', mb: '1rem' }}>
              <Typography fontSize="14px" sx={{ mb: '4px' }}>{t('visit_form.step_three.day_period')}</Typography>
              <Typography fontSize="20px" sx={{ textTransform: 'capitalize' }}>{date.toLocaleString(locale, optionsDate)} - {visitForm.time}</Typography>
            </Box>
          </Box>
          <Box display='flex' sx={{ mb: '32px' }}>
            <SvgIcon name="location_bookings" sx={{ m: '1rem', mr: '1.5rem' }} size="25" />
            <Box display="flex" sx={{ flexDirection: 'column' }}>
              <Typography fontSize="14px" sx={{ mb: '4px' }}>{t('visit_form.step_three.address')}</Typography>
              <Typography fontSize="20px">{propertyAddress}</Typography>
            </Box>
          </Box>
          <Box>
            <Box display="flex" sx={{
              flexDirection: 'column',
              p: '1.75rem',
              background: '#F9F9FC',
              borderRadius: '6px'
            }}
            >
              <Box
                sx={{
                  background:
                    'white',
                  width: 'fit-content',
                  p: '11px',
                  borderRadius: '5px',
                  mb: '11px'
                }}
              >
                <SvgIcon name="logged_user" size="25" />
              </Box>
              <Typography sx={{ lineHeight: '30px', fontSize: '1rem' }}>{t('visit_form.step_three.agent')}</Typography>
            </Box>
          </Box>
          <FormControl
            error={!!getErrorMessage('agreement')}
            sx={{ pb: 1 }}
            formHelperText={getErrorMessage('agreement')}
          >
            <FormControlLabel
              control={
                <Checkbox
                  name="agreement"
                  icon={<SvgIcon name="unchecked_checkbox" width="1rem" height="1rem" />}
                  checkedIcon={<SvgIcon name="checked_checkbox" width="1rem" height="1rem" />}
                  sx={{ ml: 0.5 }}
                  value={checkboxValue}
                  disabled={loading}
                  onChange={handleCheckbox}
                />
              }
              label={(
                <Typography
                  alignSelf="center"
                  fontSize={14}
                  color="primary.main"
                >
                  {t('dictionary.policies_agreement_text')}
                  <Link href={t('privacy_policy_path')} target="_blank" fontWeight={600} mx={0.25}>
                    {t('dictionary.policies_agreement_link')}
                  </Link>
                </Typography>
              )}
            />
          </FormControl>
          {!memberSignedIn && (
            <Box sx={{ my: '1rem', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <ReCAPTCHA sitekey={siteKey} ref={recaptchaRef} />
              <Box>
                {!!getErrorMessage('recaptcha') && (<Typography sx={{ fontSize: '0.75rem', color: '#FF5252' }}>
                  <SvgIcon name='error_input_icon' mr={0.375} />
                  {getErrorMessage('recaptcha')}
                </Typography>)
                }
              </Box>
            </Box>
          )}
          <Divider sx={{ mt: '32px' }} />
          <Box display="flex" sx={{ mt: '24px' }}>
            <Button
              size="large"
              onClick={() => handleSetStep({ step: 'two' })}
              variant='outlined'
              disabled={loading}
              sx={{ width: '100%', mr: '0.75rem' }}
            >
              {t('visit_form.back_button')}
            </Button>
            <Button
              size="large"
              sx={{ width: '100%', ml: '0.75rem' }}
              disabled={loading}
              loading={loading}
              onClick={() => handleSubmit()}
            >
              {t('visit_form.step_three.confirm_button')}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default StepThree;
